export default __webpack_public_path__ + "static/46-fb99a3d660bd4d380c2b8722f67e6c31.png";